import { createAction, createSlice } from '@reduxjs/toolkit';

export const fetchCategoriesRequest = createAction('whatsappCategories/fetchCategoriesRequest');

const initialState = {
    categories: [],
    loading: false,
    error: null,
    lastUpdated: null,
    isCached: false
};

const whatsappCategoriesSlice = createSlice({
    name: 'whatsappCategories',
    initialState,
    reducers: {
        fetchCategoriesStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchCategoriesSuccess(state, action) {
            state.loading = false;
            state.categories = action.payload;
            state.lastUpdated = new Date().getTime();
            state.isCached = true;
            state.error = null;
        },
        fetchCategoriesFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        resetCategoriesState(state) {
            state.loading = false;
            state.error = null;
        }
    }
});

export const {
    fetchCategoriesStart,
    fetchCategoriesSuccess,
    fetchCategoriesFailure,
    resetCategoriesState
} = whatsappCategoriesSlice.actions;

export default whatsappCategoriesSlice.reducer;
